import {
  FETCH_MERCHANT_BEGIN,
  FETCH_MERCHANT_SUCCESS,
  FETCH_MERCHANT_FAILURE,
  FETCH_MERCHANT_CURRENCY,
  FETCH_VIPTIERS_BEGIN,
  FETCH_VIPTIERS_SUCCESS,
  FETCH_VIPTIERS_FAILURE,
  FETCH_MEMBERSSHIPPROGRAM_BEGIN,
  FETCH_MEMBERSSHIPPROGRAM_SUCCESS,
  FETCH_MEMBERSSHIPPROGRAM_FAILURE,
  FETCH_LIMITEDTIMEOFFERPROGRAM_BEGIN,
  FETCH_LIMITEDTIMEOFFERPROGRAM_SUCCESS,
  FETCH_LIMITEDTIMEOFFERPROGRAM_FAILURE,
} from "./constants/constants";

import { base_url } from "../api/api";

export const fetchMerchant = (shopDomain) => {
  return (dispatch) => {
    dispatch(fetchMerchantBegin());
    base_url
      .get(`/merchant-info/?shopDomain=${shopDomain}`)
      .then((response) => {
        // console.log(response.data);
        dispatch(fetchMerchantSuccess(response.data));
        dispatch(fetchMerchantCurrency(response.data?.currency));
      })
      .catch((err) => {
        const errMsg = err.message;
        console.log(errMsg);
        dispatch(fetchMerchantFailure(errMsg));
      });
  };
};

const fetchMerchantBegin = () => ({
  type: FETCH_MERCHANT_BEGIN,
});

const fetchMerchantSuccess = (merchant) => {
  return {
    type: FETCH_MERCHANT_SUCCESS,
    payload: merchant,
  };
};

const fetchMerchantFailure = (error) => ({
  type: FETCH_MERCHANT_FAILURE,
  payload: error,
});

const fetchMerchantCurrency = (currency) => {
  let symbol = currency.symbol.replace(/<[^>]+>/g, "");
  symbol = symbol.replace(/{{\b\w+}}/g, "");

  return {
    type: FETCH_MERCHANT_CURRENCY,
    payload: symbol,
  };
};

// Vip tiers
export const fetchVipTiers = (shopDomain) => {
  return (dispatch) => {
    dispatch(fetchVipTiersBegin());
    base_url
      .get(`/get/vip-tiers?shopDomain=${shopDomain}`)
      .then((response) => {
        // console.log(response.data);
        dispatch(fetchVipTiersSuccess(response.data));
      })
      .catch((err) => {
        const errMsg = err.message;
        console.log(errMsg);
        dispatch(fetchVipTiersFailure(errMsg));
      });
  };
};

const fetchVipTiersBegin = () => ({
  type: FETCH_VIPTIERS_BEGIN,
});

const fetchVipTiersSuccess = (vipTiers) => {
  return {
    type: FETCH_VIPTIERS_SUCCESS,
    payload: vipTiers,
  };
};

const fetchVipTiersFailure = (error) => ({
  type: FETCH_VIPTIERS_FAILURE,
  payload: error,
});

// Membership Program
export const fetchMembershipProgram = (shopDomain) => {
  return (dispatch) => {
    dispatch(fetchMembershipProgramBegin());
    base_url
      .get(`/membershipProgram?myShopifyDomain=${shopDomain}`)
      .then((response) => {
        dispatch(fetchMembershipProgramSuccess(response.data));
      })
      .catch((err) => {
        const errMsg = err.message;
        console.log(errMsg);
        dispatch(fetchMembershipProgramFailure(errMsg));
      });
  };
};

const fetchMembershipProgramBegin = () => ({
  type: FETCH_MEMBERSSHIPPROGRAM_BEGIN,
});

const fetchMembershipProgramSuccess = (membershipProgramDetails) => {
  return {
    type: FETCH_MEMBERSSHIPPROGRAM_SUCCESS,
    payload: membershipProgramDetails,
  };
};

const fetchMembershipProgramFailure = (error) => ({
  type: FETCH_MEMBERSSHIPPROGRAM_FAILURE,
  payload: error,
});

// Limited Time Offer Program
export const fetchLimitedTimeOfferProgram = (shopDomain) => {
  return (dispatch) => {
    dispatch(fetchLimitedTimeOfferProgramBegin());
    base_url
      .get(`/limitedTimeOfferProgram?myShopifyDomain=${shopDomain}`)
      .then((response) => {
        dispatch(fetchLimitedTimeOfferProgramSuccess(response?.data));
      })
      .catch((err) => {
        const errMsg = err.message;
        console.log(errMsg);
        dispatch(fetchLimitedTimeOfferProgramFailure(errMsg));
      });
  };
};

const fetchLimitedTimeOfferProgramBegin = () => ({
  type: FETCH_LIMITEDTIMEOFFERPROGRAM_BEGIN,
});

const fetchLimitedTimeOfferProgramSuccess = (limitedTimeOfferProgramDetails) => {
  return {
    type: FETCH_LIMITEDTIMEOFFERPROGRAM_SUCCESS,
    payload: limitedTimeOfferProgramDetails,
  };
};

const fetchLimitedTimeOfferProgramFailure = (error) => ({
  type: FETCH_LIMITEDTIMEOFFERPROGRAM_FAILURE,
  payload: error,
});